module.exports = __webpack_public_path__ + "static/dl1-lang-cc8e985bb66c730e27196e7be3574ab1.png";